import { render, staticRenderFns } from "./AllergyCategory.vue?vue&type=template&id=53211c71"
import script from "./AllergyCategory.vue?vue&type=script&lang=ts"
export * from "./AllergyCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53211c71')) {
      api.createRecord('53211c71', component.options)
    } else {
      api.reload('53211c71', component.options)
    }
    module.hot.accept("./AllergyCategory.vue?vue&type=template&id=53211c71", function () {
      api.rerender('53211c71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/components/AllergyCategory.vue"
export default component.exports